import React from 'react'

export default function PreviewPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first page
            pages.push(1);
            
            if (currentPage > 3) {
                pages.push('...');
            }
            
            // Show pages around current page
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);
            
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            
            if (currentPage < totalPages - 2) {
                pages.push('...');
            }
            
            // Always show last page
            pages.push(totalPages);
        }
        
        return pages;
    };

    return (
        <div className="flex justify-center items-center gap-1 py-6">
            {/* Previous button */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-3 py-1.5 text-[11px] font-medium rounded-md border border-[#A1A1A9] transition-colors
                    ${currentPage === 1 
            ? 'text-[#A1A1A9] cursor-not-allowed bg-[#F4F4F5]' 
            : 'text-[#52525A] hover:bg-[#282828] hover:text-white cursor-pointer bg-white'}`}
            >
                Prev
            </button>

            {/* Page numbers */}
            {getPageNumbers().map((page, index) => (
                page === '...' ? (
                    <span key={`ellipsis-${index}`} className="px-2 text-[11px] text-[#717179]">...</span>
                ) : (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`w-8 h-8 text-[11px] font-medium rounded-md border transition-colors
                            ${currentPage === page 
                        ? 'bg-[#282828] text-white border-[#282828]' 
                        : 'bg-white text-[#52525A] border-[#A1A1A9] hover:bg-[#282828] hover:text-white cursor-pointer'}`}
                    >
                        {page}
                    </button>
                )
            ))}

            {/* Next button */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1.5 text-[11px] font-medium rounded-md border border-[#A1A1A9] transition-colors
                    ${currentPage === totalPages 
            ? 'text-[#A1A1A9] cursor-not-allowed bg-[#F4F4F5]' 
            : 'text-[#52525A] hover:bg-[#282828] hover:text-white cursor-pointer bg-white'}`}
            >
                Next
            </button>
        </div>
    )
}
